var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "b8804453bcff07c061fa087774e76aff6aada804"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-es@rodi"] = {
  id: "b8804453bcff07c061fa087774e76aff6aada804"
};